import $ from 'jquery';

$(document).ready(function () {
    $('.cmd-slider').each(function () {
        var $slider = $(this);
        Plugin.call($slider, $slider.data());
    })
});

function Plugin(option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('cmd.slider');
        var options = $.extend({}, $this.data(), option);

        if (!data) {
            $this.data('cmd.slider', (data = new Slider(this, options)));
        }
    });
}

var Slider = function (element, options) {
    var slider = this;
    slider.$element = $(element);
    slider.$elementInner = slider.$element.children('.cmd-slider-inner').first();
    slider.$items = slider.$elementInner.children('.cmd-slider-item');
    slider.$firstItem = slider.$items.first();
    slider.$lastItem = slider.$items.last();
    slider.$sliderPrev = slider.$element.find('.cmd-slider-prev').first();
    slider.$sliderNext = slider.$element.find('.cmd-slider-next').first();
    slider.options = options;

    slider.$sliderNext.on('click', function (e) {

        $(this).css('pointer-events', 'none');
    });

    slider.$sliderPrev.on('click', function (e) {

        // if (slider.getOffset() == 0) return;

        $(this).css('pointer-events', 'none');
    });

    slider.$firstItem.on('transitionend', function () {
        var slidedEvent = $.Event('cmd.slided', { offset: slider.getOffset(), amount: slider.getSliderStepAmount(), step: slider.$elementInner.width() / 12 });
        slider.$element.trigger(slidedEvent);

        slider.$sliderPrev.css('pointer-events', 'all');
        slider.$sliderNext.css('pointer-events', 'all');
    });

    slider.$elementInner.css('flex-wrap', 'nowrap');
    slider.$sliderNext.on('click', function () {
        slider.next();
    });

    slider.$sliderPrev.on('click', function () {
        slider.prev();
    });

    slider.$firstItem.css({
        'transition-property': 'margin-left',
        'transition-duration': '0.5s'
    });

    slider.$element.css('position', 'relative');
    slider.$elementInner.css('overflow', 'hidden');
    slider.$lastItem.css('margin-right', '-99999999999px');
}

Slider.prototype.getTotalItemWidth = function () {
    var totalWidth = 0;

    this.$items.each(function () {
        totalWidth += $(this).outerWidth();
    })

    return totalWidth;
}

Slider.prototype.next = function () {
    var amount = this.getSliderStepAmount();
    return this.slide('next', amount);
}

Slider.prototype.prev = function () {
    var amount = this.getSliderStepAmount();
    return this.slide('prev', amount);
}

Slider.prototype.getSliderStepAmount = function () {
    var viewportWidth = getViewportWidth();
    var classes = this.$elementInner.attr('class').split(/\s+/);
    var result = NaN;

    for (var i = 0; i < classes.length; i++) {
        if (classes[i].startsWith('step-' + viewportWidth + '-')) {
            var parts = classes[i].split('-');
            result = parseInt(parts[2]);
            break;
        }
    }

    if (!isNaN(result)) return result;

    for (var i = 0; i < classes.length; i++) {
        if (classes[i].startsWith('step-')) {
            var parts = classes[i].split('-');

            result = parseInt(parts[1]);
            break;
        }
    }

    if (!isNaN(result)) return result;

    return 12;
}

Slider.prototype.slide = function (direction, amount) {
    console.log("--------------------------------------");
    console.log("direction");
    console.log(direction);
    console.log("amount");
    console.log(amount);
    if (typeof amount != 'number') amount = 0;

    amount = Math.round(amount);

    if (amount < 0) amount = 0;
    if (amount > 12) amount = 12;

    var step = this.$elementInner.width() / 12;
    var offset = parseFloat(this.$firstItem.css('margin-left'));

    if (direction == 'next') {
        var totalWidth = this.getTotalItemWidth();
        offset = offset - (amount * step);
        if (Math.abs(offset) >= totalWidth) offset = 0;
    } else if (direction == 'prev') {
        // offset = offset + (amount * step);
        // if (offset >= 0) offset = 0;
        if (offset == 0){
            offset = -2460;
        }else{
            offset = offset + (amount * step);
        }
    }

    this.$firstItem.css('margin-left', offset + 'px');

    return this;
}

Slider.prototype.slideTo = function (offset) {
    this.$firstItem.css('margin-left', offset + 'px');
}

Slider.prototype.getOffset = function () {
    return parseFloat(this.$firstItem.css('margin-left'));
}

$.fn.slider = Plugin;
$.fn.slider.constructor = Slider;


var getViewportWidth = function () {
    return $('#viewportSize').find('div:visible').first().attr('id');
}


// WEBPACK FOOTER //
// ./resources/assets/js/slider.js